import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlined";
import { Box, Divider, Menu } from "@mui/material";
import { useSelector } from "react-redux";
import { pageRoutes } from "../../routes";
import { impersonationSelector } from "../../store/state/user/selectors";
import UserMenuItem from "./UserMenuItem";
import UserComponent from "./user/UserComponent";

interface Props {
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

export const UserMenu = (props: Props) => {
  const { anchorEl, onClose } = props;

  const isImpersonation = useSelector(impersonationSelector);

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      onClick={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: 40, vertical: 50 }}
      slotProps={{ paper: { sx: { width: "18rem" } } }}
    >
      <Box sx={{ mt: 1, mb: 2, mx: 2 }}>
        <UserComponent />
      </Box>
      <Divider sx={{ m: 1 }} />
      <UserMenuItem text="My Profile" page={`${pageRoutes.user}/profile`} Icon={PersonIcon} />
      <Divider sx={{ m: 1 }} />
      <UserMenuItem text="Log out" page="logout" Icon={LogoutIcon} disabled={isImpersonation} />
    </Menu>
  );
};

export default UserMenu;
